import { UntypedFormGroup } from '@angular/forms';
import { ApplianceDetailsAdditionalAppliancesFormField } from './appliance-details-additional-appliances-form-field.enum';

export interface ApplianceDetailsAdditionalAppliancesForm {
  [ApplianceDetailsAdditionalAppliancesFormField.AdditionalAppliances]: UntypedFormGroup;
}
